import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useWindowEvent } from "../../hooks";
import lnMap from "../../languages/language-maps/shared-lang-map";

function DropdownLogic({
  items,
  List,
  Item,
  Button,
  ToggleButton,
  ToggleContainer,
  IconContainer,
  absolute,
  width,
  onItemClick,
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentItem, setCurrentItem] = useState(items[0]?.name || "");
  const closeDropdown = () => setShowDropdown(false);
  const ref = useRef();
  useWindowEvent({
    events: [{ event: "click" }],
    handlers: [
      (e) => {
        if (!ref?.current?.contains(e.target)) {
          closeDropdown();
        }
      },
    ],
    condition: true,
  });

  const { t } = useTranslation();

  const handleItemClick = (item) => {
    setCurrentItem(item.name);
    onItemClick && onItemClick(item);
    closeDropdown();
  };

  const handleToggleClick = () => {
    setShowDropdown(!showDropdown);
  };

  return (
    <>
      <div
        style={{
          position: absolute ? "relative" : "static",
          width,
          maxWidth: "100%",
        }}
        ref={ref}
      >
        <ToggleContainer style={{ position: "relative" }} active={showDropdown}>
          <ToggleButton value={currentItem} onClick={handleToggleClick}>
            {t(lnMap[currentItem])}
          </ToggleButton>
          {IconContainer && <IconContainer active={showDropdown} />}
        </ToggleContainer>
        {showDropdown && (
          <List style={{ position: absolute }}>
            {items.map((item) => (
              <Item key={item.name}>
                <Button
                  onClick={(e) => {
                    handleItemClick(item);
                  }}
                  {...item.handlers}
                >
                  {t(lnMap[item.name])}
                </Button>
              </Item>
            ))}
          </List>
        )}
      </div>
    </>
  );
}

export default DropdownLogic;
